type ICURRENCY = {
  [key: string]: string;
};
export const CURRENCY: ICURRENCY = {
  USD: '$',
  EUR: '€',
  GBP: '£'
};

export const SUBSCRIBE_STATUS = {
  Active: 'Active',
  Cancelled: 'Cancelled'
};

export const FREE_TRIAL_DURATION: number = 30;

export const NAVIGATION_ROUTES = {
  DEFAULT: '/',
  LOGIN: '/login',
  AUTO_LOGIN: '/auto-login',
  AUTHORIZE_DEVICE: '/authorizeDevice',
  AUTHORIZE_FROM_APP: '/authorizeFromApp',
  REQUEST_DELETE_SERVICES: '/requestDeleteServices',
  VERIFY_DELETE_SERVICES: '/verifyDeleteServices',
  APP_BRIDGE: '/app-bridge',
  BRIDGE: '/bridge',
  ACTIVE_DEVICES: '/ActiveDevices',
  MY_ACCOUNT: '/MyAccount',
  MY_SUBSCRIPTION: '/MySubscription',
  BILLINGS: '/Billings',
  BUY_SUBSCRIPTION: '/buySubscription',
  CHECKOUT_SESSION: '/checkout-session',
  PLAN_LIST: '/planlist',
  PLAN_LIST_INTERCEPTOR: '/planlistInterceptor',
  PAYMENT_SELECTIONS: '/payment-selections',
  PAYMENT_SUCCESS: '/payment-success',
  PAIRING_SUCCESS: '/pairing-success',
  SETUP_INIT: '/setup-init',
  SETUP_COMPLETE: '/setup-complete',
  SELECT_DEVICE: '/selectDevice',
  PROMOTION: '/promotion',
  SUBSCRIPTION_FUNCTIONS: '/subscription-functions',
  WHY_SKIP: '/why-skip',
  // MISSED_FEATURES: '/missed-features',
  SKIP_TRIAL: '/skip-trial',
  CAMERA_SELECTION: '/camera-selection',
  CANCELLATION_REFUND_POLICY: '/cancellation-refund-policy',
  OTHER_ROUTES: '*'
};
